import { queryOptions, type UseQueryOptions } from '@tanstack/react-query';
import type {
  GetDuoByUserIdData,
  GetDuoByUserIdResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';
import type { ReplacePathParams } from '@/shared/utils/pathParams';

export interface DuoDetailsKeyParams {
  userId: string;
}

const getDuoDetailsUrl = (
  userId: string | number,
): ReplacePathParams<GetDuoByUserIdData['url']> => `duos/${userId.toString()}`;

export const getDuoDetailsKey = ({ userId }: DuoDetailsKeyParams) =>
  ['duos', 'details', userId] as const;

export const getDuoDetailsOptions = <T = GetDuoByUserIdResponse>(
  params: DuoDetailsKeyParams,
  options?: Omit<
    UseQueryOptions<GetDuoByUserIdResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >,
) => {
  return queryOptions<GetDuoByUserIdResponse, unknown, T>({
    queryKey: getDuoDetailsKey(params),
    queryFn: () =>
      PrivateApi.get(
        getDuoDetailsUrl(params.userId),
      ).json<GetDuoByUserIdResponse>(),
    ...options,
  });
};
